import AuthorizationContext     from 'auth/keycloak-instance';
import Product                  from './product'
import useTranslate             from 'app/common/hooks/translate';
import useUptimeStatuses        from 'app/common/hooks/uptime-status';

const AllProducts = props => {
    const t             = useTranslate();
    const products      = AuthorizationContext.user.unAuthorizedProducts;
    const statuses      = useUptimeStatuses();

    const renderProductList = () => {
        return (
            products
            .map((item, index) => (
                <Product
                    item                    = { item }
                    index                   = { index }
                    key                     = { 'p-' + index }
                    toggleApplicationLoader = { (url) => props.toggleApplicationLoader(url) }
                    isAvailable             = { false }
                    status                  = { statuses[item.name] }
                />
            ))
        )
    }

    return (
        <div className="product-selection-container">
            <div className="product-selection-header">
                <div>
                    <h1>{ t('New_Customer_Meet_Our_Products') }</h1>
                    <h2>{ t('New_Customer_Meet_Our_Products_Description') }</h2>
                </div>
            </div>

            <div className="product-list-container">
                { renderProductList() }
            </div>
        </div>
    )
}

export default AllProducts